import React, { useEffect, useState } from "react";
import { navigate } from "gatsby";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import { getFilteredResults } from "../../../services/filter";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import BookSlider from "../book-slider/bookSlider";
import Loading from "../../atoms/loading/loading";
import Button from "../../atoms/button/button";

import "./bookCarousel.scss";

const BookCarousel = (props: ReferenciaContenido) => {
  const [books, setBooks] = useState<any[] | null>(null);

  const seeAll = () => {
    const collection = props.etiquetasArticulo ? props.etiquetasArticulo[0] : "";
    const subjects = props.autoresArticulo ? props.autoresArticulo.join("/") : "";
    const serie = props.nombreSerie ? props.nombreSerie[0] : ""
    navigate(`/ver-todo/?title=${props.tituloGeneral}` +
    `&searchType=filter` +
    `&contentType=Libros` + 
    `&searchParam=word,contentType` +
    `&paramValues=${serie}/-${props.tipoLibro || ""}/-${subjects}/-${collection}/-/-${serie}`,
     {
      state: {
      },
    });
  };

  const getBooks = async () => {
    const collection = props.etiquetasArticulo ? props.etiquetasArticulo[0] : "";
    const subjects = props.autoresArticulo ? props.autoresArticulo.join("/") : "";
    const serie = props.nombreSerie ? props.nombreSerie[0] : ""
    const booksReq = await getFilteredResults("", props.tipoLibro || "", "12", subjects, collection, "", serie);
    setBooks(booksReq?.data.data.filter)
  }

  useEffect(() => {
    getBooks();
  }, []);

  return (
    <div className="m-book-carousel">
      <div className="m-book-carousel__upper">
        <h2 className="m-book-carousel__upper-title">{props.tituloGeneral}</h2>
        <Button
          type="button"
          classname={`m-book-carousel__upper-button 
            ${!books || books.length < 12 ? "m-book-carousel__upper-button--hide" : ""}`}
          text={props.tituloBoton}
          isDisabled={false}
          onClickAction={seeAll}
          gtmMark={`gtm${normalizeTwoWords(props.nombreCategoria)}${normalizeTwoWords(props.tituloGeneral)}${normalizeTwoWords(props.tituloBoton)}`
          }
        />
      </div>

      <div className="m-book-carousel__featured">
        {books && books.length > 0 ?
          <BookSlider books={books} gtmClass={props.nombreCategoria} /> : <Loading />
        }
      </div>
    </div>
  );
};

export default BookCarousel;